// jQuery
global.jQuery = global.$ = require('jquery');

// Hiraku
global.Hiraku = require('hiraku');

// autosize
global.autosize = require('autosize');

// micro-modal
global.MicroModal = require('micromodal');

/**
 * pointer touch mouse click イベントのクロスブラウザ対応
 * https://qiita.com/motio/items/cf23e41b211cfa44f8b3
 */
// userAgent
global.sUserAgent = window.navigator.userAgent.toLowerCase();

global.oDeviceEvents = {
	Touch     : typeof document.ontouchstart !== 'undefined',
	Pointer   : window.navigator.pointerEnabled,
	MSPointer : window.navigator.msPointerEnabled
};
global.oEventNames = {
	start :
		oDeviceEvents.Pointer ? 'pointerdown' :
			oDeviceEvents.MSPointer ? 'MSPointerDown' :
				oDeviceEvents.Touch ? 'touchstart' : 'mousedown',
	move : oDeviceEvents.Pointer ? 'pointermove' :
		oDeviceEvents.MSPointer ? 'MSPointerMove' :
			oDeviceEvents.Touch ? 'touchmove' : 'mousemove',
	/*
	※endの最後をmouseupにする場合、中・右クリックにも反応してしまうため制御を忘れないように注意。
	※IEはpointerup対応により中・右クリックにも反応してしまうので、最初にユーザーエージェントにて分岐しclickイベントで処理させてる。
	※タッチ式PCのChrome対応で、touchend clickを同時指定
	*/
	end : sUserAgent.indexOf('msie') != -1 || sUserAgent.indexOf('trident') != -1 ? 'click' :
		oDeviceEvents.Pointer ? 'pointerup' :
			oDeviceEvents.MSPointer ? 'MSPointerUp' :
				oDeviceEvents.Touch ? 'touchend click' : 'click' /*'mouseup'*/
};

// スクロール中かどうか
global.bIsScrolling = false;
var $oTimerScrolling;
$('window, body').on('scroll touchmove', function() {
	global.bIsScrolling = true;
	clearTimeout($oTimerScrolling);
	$oTimerScrolling = setTimeout( function () {
		global.bIsScrolling = false;
	},500);
});

// loading HTML
global.sLoadingHtml = '<div id="loading-animation"><span></span></div>';